const serviceRoot = 'api/AdditionalInfoRequest/';

export const AdditionalInfoEndpoints = {
  getAdditionalInfoDetails: () => `${serviceRoot}getAdditionalInfoDetails`,
  getAdditionalInfoRequests: () => `${serviceRoot}getAdditionalInfoRequests`,
  saveAdditionalInfoResponse: () => `${serviceRoot}updateAdditionalInfoResponse`,
};
